export default {
  className: 'share',
  fields: [
    {
      // 共享人
      name: 'user',
      listWhere: (where) => {
        where.status = 'ordinary'
      }
    },
    {
      // 接收人
      name: 'takeUser',
      listWhere: (where) => {
        where.status = 'ordinary'
      }
    }
  ],
  search: [
    'user',
    'takeUser'
  ],
  action: false
}
